import { render } from "./app-sidebar-item-node.vue?vue&type=template&id=021cd5a6"
import script from "./app-sidebar-item-node.vue?vue&type=script&lang=js"
export * from "./app-sidebar-item-node.vue?vue&type=script&lang=js"
script.render = render

export default script